// components/FaqSection.js
import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import '../CSS/HomeFaqSection.css'
import { Start } from '@mui/icons-material';
import { FiChevronDown } from 'react-icons/fi';

const faqData = [
  {
    question: 'Can I order via WhatsApp?',
    answer:
      'We advise you to place your order only through our website.',
  },
  {
    question: 'How long do I need to wait after submitting an order?',
    answer: 'You will receive the card link immediately after payment is verified.',
  },
  {
    question: 'Can I change my details after created a card?',
    answer: 'Yes, you can still edit your details after the card is created.',
  },
  {
    question: 'How do I make payment?',
    answer:
      'You need to make payment via the DuitNow QR provided and send the receipt to our admin on WhatsApp.',
  },
  {
    question: 'Is the invitation card is lifetime available?',
    answer:
      'No, invitation card will not be accessible 60 days after the end of your wedding event date.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <Typography variant="h6" fontWeight={600}>FAQ</Typography>
      <Typography variant="body1" color='text.secondary' gutterBottom>Need Help?</Typography>

      <div className="faq-list">
        {faqData.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${index !== 0 ? 'with-top-border' : ''} ${openIndex === index ? 'expanded' : ''
              }`}
          >
            <div className="faq-question" onClick={() => toggleItem(index)}>
              <span>{item.question}</span>
              <span className="faq-icon">{openIndex === index ? <FiChevronDown /> : <FiChevronDown />}</span>
            </div>
            {openIndex === index && (
              <div className="faq-answer">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}